'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.BaseService = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var createDaemon_1 = require('../utils/createDaemon');
var createActions_1 = require('../utils/createActions');
var Dependency_1 = require('./Dependency');
var getKeys_1 = require('../utils/getKeys');
var UUIDGenerator_1 = require('./UUIDGenerator');
var uuidGen = new UUIDGenerator_1.UUIDGenerator();
var BaseService = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BaseService, _super);
    function BaseService() {
        var _this = _super.call(this) || this;
        _this._status = 'unavailable';
        _this._uuid = ''.concat(uuidGen.uuid());
        _this._daemons = [];
        var methods = (0, getKeys_1.getClassMethods)(_this);
        methods.forEach(function (m) {
            var origin = _this[m];
            var bond = origin.bind(_this);
            // copy possible decorators meta
            _this[m] = Object.assign(bond, origin);
        });
        var Service = _this;
        var actions = (0, createActions_1.createActions)(Service, _this.getUUID());
        methods.forEach(function (key) {
            var method = Service[key];
            var __$daemonMode = method.__$daemonMode,
                __$action = method.__$action;
            if (!__$daemonMode) {
                return;
            }
            var daemon = (0, createDaemon_1.createDaemon)(__$action || actions[key].toString(), method, {
                mode: __$daemonMode,
            });
            _this._daemons.push(daemon);
        });
        return _this;
    }
    BaseService.prototype.run = function () {
        var _i, result, _a, _b, daemon, e_1_1;
        var e_1, _c;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    result = undefined;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    (_a = (0, tslib_1.__values)(this._daemons)), (_b = _a.next());
                    _d.label = 2;
                case 2:
                    if (!!_b.done) return [3 /*break*/, 5];
                    daemon = _b.value;
                    return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.call)(daemon.run))];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 5:
                    return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                case 8:
                    this._status = 'ready';
                    return [2 /*return*/, result];
            }
        });
    };
    BaseService.prototype.destroy = function () {
        var _i, _a, _b, daemon, e_2_1;
        var e_2, _c;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    this._status = 'unavailable';
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    (_a = (0, tslib_1.__values)(this._daemons)), (_b = _a.next());
                    _d.label = 2;
                case 2:
                    if (!!_b.done) return [3 /*break*/, 5];
                    daemon = _b.value;
                    return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.call)(daemon.destroy))];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 5:
                    return [3 /*break*/, 8];
                case 6:
                    e_2_1 = _d.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                    return [7 /*endfinally*/];
                case 8:
                    return [2 /*return*/];
            }
        });
    };
    BaseService.prototype.getStatus = function () {
        return this._status;
    };
    BaseService.prototype.getUUID = function () {
        return this._uuid;
    };
    return BaseService;
})(Dependency_1.Dependency);
exports.BaseService = BaseService;
